import React from 'react';
import PropTypes from 'prop-types';
import './StatusPaymentPill.scss';

export const STATUS = {
  APPROVED: { value: 'APPROVED', text: 'Aprobado' },
  REJECTED: { value: 'REJECTED', text: 'Rechazado' },
  PENDING: { value: 'PENDING', text: 'Pendiente' },
  EXPIRED: { value: 'EXPIRED', text: 'Vencido' },
  REFUNDED: { value: 'REFUNDED', text: 'Devuelto' },
  CANCELLED: { value: 'CANCELLED', text: 'Anulado' },
};

const StatusPaymentPill = ({ status }) => (
  <div className={`status-pill status-pill--${status.toLowerCase()}`}>
    <div className={`oval oval--${status.toLowerCase()}`} />
    <span>{STATUS[status].text}</span>
  </div>
);

StatusPaymentPill.propTypes = {
  status: PropTypes.oneOf([
    'APPROVED',
    'REJECTED',
    'PENDING',
    'EXPIRED',
    'REFUNDED',
    'CANCELLED',
  ]),
};

export default StatusPaymentPill;
